import {benefitsPaths} from '../../benefit/shared/benefit-routes';

export const userPaths = {
  auth: 'auth',
  logIn: 'login',
  logOut: 'logout',
  user: 'user',
  dashboard: 'dashboard',
  profile: 'profile',
  profileResidencyInformation: 'profileResidencyInformation',
  directory: 'directory',
  home: 'home',
  benefits: 'benefits',
  sighu: 'sighu',
  menu: 'menu',
  otherOptions: 'other-options',
  sales: 'sales-channel',
};

export const userRoutes = {
  logIn: `/${userPaths.auth}/${userPaths.logIn}`,
  logout: `/${userPaths.auth}/${userPaths.logOut}`,
  dashboard: `/${userPaths.user}/${userPaths.dashboard}`,
  home: `/${userPaths.user}/${userPaths.home}`,
  profile: `/${userPaths.user}/${userPaths.profile}`,
  profileResidencyInformation: `/${userPaths.user}/${userPaths.profileResidencyInformation}`,
  directory: `/${userPaths.user}/${userPaths.directory}`,
  homeBenefits: `/${benefitsPaths.base}/${benefitsPaths.homeBenefits}`,
  sighu: `/${userPaths.user}/${userPaths.sighu}`,
  menu: `/${userPaths.user}/${userPaths.menu}`,
  otherOptions: `/${userPaths.user}/${userPaths.otherOptions}`,
  sales: `/${userPaths.user}/${userPaths.sales}`,
};
